import searchService from "@irati/deals/services/search"

import {DEFAULT_SEARCH_LIMIT} from "../../constants/search"
import {isSearchTermValid} from "../../helpers/search/validation"

export const NEW_URL_QUERY_TERM = "NEW_URL_QUERY_TERM"
export const PEND_LOAD_RESULTS = "PEND_LOAD_RESULTS"
export const LOAD_RESULTS = "LOAD_RESULTS"
export const UPDATE_RESULTS = "UPDATE_RESULTS"
export const CLEAR_RESULTS = "CLEAR_RESULTS"
export const SET_SEARCH_RESULTS_INPUT = "SET_SEARCH_RESULTS_INPUT"
export const CLEAR_PEND = "CLEAR_PEND"

export const newUrlQueryTerm = (q) => ({
  type: NEW_URL_QUERY_TERM,
  search: {
    q
  }
})

export const pendLoadResults = () => ({
  type: PEND_LOAD_RESULTS
})

export const loadResults = (load) => ({
  type: LOAD_RESULTS,
  search: {
    load
  }
})

export const updateResults = (q, results, dealBrands) => ({
  type: UPDATE_RESULTS,
  search: {
    lastSuccessfulQ: q,
    results,
    dealBrands
  }
})

export const clearResults = () => ({
  type: CLEAR_RESULTS
})

export const setSearchResultsInput = (input) => ({
  type: SET_SEARCH_RESULTS_INPUT,
  search: {
    input
  }
})

export const clearPend = () => ({
  type: CLEAR_PEND
})

/**
 *
 * Thunk action creators
 *
 */

/**
 * newSearch: searchService returns the searchTerm q, using this along with latestSearchTerm we can only
 * dispatch and update the search results when they are the last results
 * requested.
 *
 * @author Matthew Rawson @ 08/01/2018 16:58
 * @param searchTerm
 * @param options
 * @returns {function(*=)}
 */
export const newSearch = (
  searchTerm,
  options = {
    limit: DEFAULT_SEARCH_LIMIT
  }
) => {
  return (dispatch) => {
    let load = Promise.resolve()
    const {limit = DEFAULT_SEARCH_LIMIT, isRewards, ...searchOptions} = options
    const params = {limit, isRewards, q: searchTerm}

    /** Fetch or clear results based on searchTerm validation */
    if (isSearchTermValid(searchTerm)) {
      const brandsParams = {isRewards, q: searchTerm}
      const promises = [searchService.search(params, searchOptions), searchService.searchBrands(brandsParams, searchOptions)]
      load = Promise.all(promises).then((results) => {
        const [searchResults, dealBrandsRes] = results
        dispatch(updateResults(searchResults.data.q, searchResults, dealBrandsRes.brands))
      })
      dispatch(loadResults(load))
    } else {
      dispatch(clearResults())
    }

    /** Regardless of whether the search term is valid update the state to what the latest url query state */
    dispatch(newUrlQueryTerm(searchTerm))
    return load
  }
}

export const retryLastSearch = () => {
  return (dispatch, getState) => {
    const {q, options} = getState().search
    return dispatch(newSearch(q, {...options, delay: 0}))
  }
}

/**
 * Export all
 */
export default {
  LOAD_RESULTS,
  UPDATE_RESULTS,
  newSearch,
  retryLastSearch
}
